import React from 'react';
import { IIconProps } from './IIconProps';

export const TemplateItemIcon = ({
	iconClass = '',
	title = '',
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 135 122"
			className={`icon ${iconClass}`}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M135 76.376L91.0163 0L69.1001 38.0565C62.1764 33.7456 54.0065 31.2562 45.2567 31.2562C20.2621 31.2562 0 51.5699 0 76.6281C0 101.686 20.2621 122 45.2567 122C70.2513 122 90.5134 101.686 90.5134 76.6281C90.5134 76.544 90.5131 76.46 90.5127 76.376H135ZM47.0325 76.376H90.5127C90.4249 60.1947 81.8881 46.0187 69.1001 38.0565L47.0325 76.376Z"
				fill="#070D58"
				fillOpacity="0.05"
			/>
		</svg>
	);
};
